<template>
  <el-dialog
    width="25%"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    @beforeClose="handleCloseDialog"
    :title="$t('Dev_add_dev')"
    class="add-devices-to-pond"
    custom-class="add-devices-dialog"
  >
    <el-form size="small">
      <el-form-item :label="$t('Comn_pond')">
        <el-col :span="24">
          <el-input
            :value="this.pond_details && this.pond_details.title"
            disabled
          ></el-input>
        </el-col>
      </el-form-item>
      <el-form-item :label="$t('Comn_pond_guard')">
        <el-col :span="24">
          <er-select
            v-model="selectedPGs"
            :showSelectAll="true"
            class="select-devices"
            value-key="code"
            collapse-tags
            multiple
            filterable
            placeholder="Select"
            :no-data-text="$t('Comn_no_pondguards')"
          >
            <el-option
              v-for="item in pond_guards"
              :key="item._id"
              :label="item.code"
              :value="item"
            ></el-option>
          </er-select>
        </el-col>
      </el-form-item>
      <el-form-item :label="$t('Comn_pond_mother')">
        <el-col :span="24">
          <er-select
            v-model="selectedPMs"
            :showSelectAll="true"
            class="select-devices"
            value-key="code"
            collapse-tags
            multiple
            filterable
            placeholder="Select"
            :no-data-text="$t('Comn_no_pondmothers')"
          >
            <el-option
              v-for="item in pond_mothers"
              :key="item._id"
              :label="item.code"
              :value="item"
            ></el-option>
          </er-select>
        </el-col>
      </el-form-item>

      <el-form-item :label="$t('Comn_shrimptalk')">
        <el-col :span="24">
          <er-select
            class="select-devices"
            :showSelectAll="true"
            v-model="selectedSTs"
            value-key="code"
            collapse-tags
            multiple
            filterable
            placeholder="Select"
            :no-data-text="$t('Comn_no_shrimptalks')"
          >
            <el-option
              v-for="item in shrimp_talks"
              :key="item._id"
              :label="item.code"
              :value="item"
            ></el-option>
          </er-select>
        </el-col>
      </el-form-item>
    </el-form>

    <layout-toolbar slot="footer" justify="center">
      <er-button
        size="mini"
        btnType="save"
        :showLabel="true"
        :showIcon="true"
        :loading="loading"
        @click="submitDeviceDetails"
        :disabled="isReadOnly"
      ></er-button>
      <er-button
        size="mini"
        btnType="cancel"
        :showLabel="true"
        @click="handleCloseDialog"
        :disabled="isReadOnly"
      ></er-button>
    </layout-toolbar>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import errorHandlerMixin from "@/mixins/errorHandlerMixin";
export default {
  mixins: [errorHandlerMixin],
  props: {
    pond_details: {
      default: {}
    },
    showDialog: {
      default: false
    }
  },
  data: function() {
    return {
      pond_guards: [],
      pond_mothers: [],
      shrimp_talks: [],
      selectedPMs: [],
      selectedSTs: [],
      selectedPGs: [],
      query: {
        get_all: true,
        include: ["title", "code"],
        un_assigned_only: true
      },
      loading: false
    };
  },
  async created() {
    await this.initComponent();
  },
  computed: {
    ...mapGetters("user", {
      isReadOnly: "isReadOnly"
    }),
    dialogVisible: {
      get() {
        return this.showDialog;
      },
      set(value) {
        this.handleCloseDialog("close");
      }
    }
  },
  methods: {
    handleCloseDialog(event) {
      this.selectedSTs = [];
      this.selectedPMs = [];
      this.selectedPGs = [];
      this.$emit("close_dialog", event);
    },
    async initComponent() {
      try {
        const pmQueryParams = {
          ...this.query,
          include: ["title", "code", "managed_by"]
        };
        await this.$store.dispatch(
          "pondmother/fetchAllPondMothers",
          pmQueryParams
        );
        this.pond_mothers = this.$lodash.cloneDeep(
          this.$store.getters["pondmother/getPondMothers"]
        );
        this.pond_mothers.sort((a, b) => a.code.localeCompare(b.code));
      } catch (err) {
        this.errorMessages(err, true);
      }
      try {
        await this.$store.dispatch(
          "shrimptalk/fetchAllShrimpTalks",
          this.query
        );
        this.shrimp_talks = this.$lodash.cloneDeep(
          this.$store.getters["shrimptalk/getShrimpTalks"]
        );
        this.shrimp_talks.sort((a, b) => a.code.localeCompare(b.code));
      } catch (err) {
        this.errorMessages(err, true);
      }
      try {
        await this.$store.dispatch("pondguard/fetchAllPondGuards", this.query);
        this.pond_guards = this.$lodash.cloneDeep(
          this.$store.getters["pondguard/getPondGuards"]
        );
        this.pond_guards.sort((a, b) => a.code.localeCompare(b.code));
      } catch (err) {
        this.errorMessages(err, true);
      }
    },
    async submitDeviceDetails() {
      this.loading = true;
      try {
        const payload = this.selectedPMs.map(pmArg => {
          const pm = this.$lodash.cloneDeep(pmArg);
          return {
            pond_id: this.pond_details._id,
            status: "ACTIVE",
            managed_by: pm.managed_by === undefined ? "FARMER" : pm.managed_by,
            title: pm.title || pm.code,
            pond_mother_id: pm._id
          };
        });
        if (payload.length > 0) {
          await this.$store.dispatch(
            "pondmother/addPondMotherDetails",
            payload
          );
        }
        const payload1 = this.selectedSTs.map(stArg => {
          const st = this.$lodash.cloneDeep(stArg);
          return {
            title: st.title || st.code,
            status: "ACTIVE",
            pond_id: this.pond_details._id,
            shrimp_talk_id: st._id,
            settings: {
              feed_limit: st.settings.feed_limit || 0
            }
          };
        });
        if (payload1.length > 0) {
          await this.$store.dispatch(
            "shrimptalk/addShrimpTalkDetails",
            payload1
          );
        }
        const payload2 = this.selectedPGs.map(pgArg => {
          const pg = this.$lodash.cloneDeep(pgArg);
          pg.title = pg.title || pg.code;
          pg.status = "ACTIVE";
          pg.pond_id = this.pond_details._id;
          delete pg.settings;
          return pg;
        });
        if (payload2.length > 0) {
          await this.$store.dispatch("pondguard/addPondGuardDetails", payload2);
        }
        if (
          payload.length === 0 &&
          payload1.length === 0 &&
          payload2.length === 0
        ) {
          throw {
            type: "FAIL_TO_SAVE",
            errors: [
              {
                message: this.$t("DL_no_device_selected")
              }
            ]
          };
        }
        this.$notify({
          title: this.$t("Usrs_success_msg"),
          message: "Devices Successfully Added",
          duration: 5000,
          type: "success"
        });
      } catch (err) {
        const errors = [];
        console.log(err.response);
        if (err.response && err.response.data.errors != null) {
          err.response.data.errors.details.forEach((el, index) => {
            errors.push({ message: el.message });
          });
          this.errorFailToSave(errors);
        } else if (err.response && err.response.data.message) {
          errors.push({ message: err.response.data.message });

          this.errorFailToSave(errors);
        } else {
          this.errorMessages(err, true);
        }
      } finally {
        this.handleCloseDialog("deviceAddition");
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss">
.add-devices-to-pond {
  .el-dialog__body {
    padding: 15px 15px;
  }
  .el-form {
    .el-form-item__content {
      .select-devices {
        width: 200px;
      }
    }
  }
}
.add-devices-dialog {
  background: #fcfcfc;
  border-radius: 10px;

  .el-input--small .el-input__inner {
    @include responsiveProperty(width, 200px, 200px, 200px);
  }

  .el-form-item--small .el-form-item__content,
  .el-form-item--small .el-form-item__label {
    @include responsiveProperty(
      font-size,
      $app_font_size_1,
      $app_font_size_2,
      $app_font_size_3
    );
    @include responsiveProperty(width, 90px, 135px, 200px);
  }
}
</style>
